import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar as MuiAppBar,
  Box,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import HelpIcon from "@mui/icons-material/Help";
import Account from "src/app/components/Dashboard/AppBar/AccountMenu";
import SupportDialog from "src/app/components/Dashboard/AppBar/SupportDialog";
import DateFormatToggle from "src/app/components/Dashboard/AppBar/DateFormatToggle";
import { getAuthIsStudentsUser } from "src/features/auth/authSlice";
import { useAppSelector } from "src/app/hooks";

type Props = {
  isMobileNavMenuOpen: boolean;
  setIsMobileNavMenuOpen: (isMobileNavMenuOpen: boolean) => void;
};

const AppBar: React.FC<Props> = ({
  isMobileNavMenuOpen,
  setIsMobileNavMenuOpen,
}) => {
  const isStudentsUser = useAppSelector(getAuthIsStudentsUser);
  const [isSupportOpen, setIsSupportOpen] = React.useState(false);

  const handleMobileNavMenuToggle = () => {
    setIsMobileNavMenuOpen(!isMobileNavMenuOpen);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <MuiAppBar
        position="fixed"
        variant="outlined"
        elevation={0}
        color="transparent"
        sx={{
          borderLeft: "0px",
          backdropFilter: "blur(20px)",
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            onClick={handleMobileNavMenuToggle}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} />
          <DateFormatToggle />
          {!isStudentsUser && (
            <div>
              <Tooltip title="תמיכה">
                <IconButton
                  color="primary"
                  sx={{ ml: 2 }}
                  onClick={() => setIsSupportOpen(true)}
                >
                  <HelpIcon />
                </IconButton>
              </Tooltip>
            </div>
          )}
          <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
          <Account />
        </Toolbar>
      </MuiAppBar>
      <SupportDialog
        open={isSupportOpen}
        onClose={() => setIsSupportOpen(false)}
      />
    </Box>
  );
};

export default AppBar;
